import styles from "./Solution.module.css";

const skills = [
  { label: "Problem solving", val: 94 },
  { label: "Technical depth", val: 96 },
  { label: "Collaboration", val: 88 },
  { label: "Adaptability", val: 91 },
];

const checks = [
  "Profiles reviewed and approved by our team",
  "Situational Judgement Tests scored against real-world tasks",
  "AI matching tuned to your role and team culture",
  "Hiring decisions made in days, not months",
];

export default function Solution() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* Text */}
          <div className={styles.text}>
            <span className={styles.eyebrow}>The Awasource way</span>
            <h2 className={styles.h2}>
              Verified talent. Smart matches. Real data.
            </h2>
            <p className={styles.body}>
              Awasource combines profile review, role-specific assessments, and
              AI-powered matching into a single platform. Every candidate is
              reviewed, profiled, and ranked — so your team only spends time on
              the matches worth interviewing.
            </p>
            <ul className={styles.checkList}>
              {checks.map((c) => (
                <li key={c}>
                  <span className={styles.checkIcon}>✓</span>
                  {c}
                </li>
              ))}
            </ul>
          </div>

          {/* Visual */}
          <div className={styles.visual}>
            <div className={styles.profileCard}>
              <div className={styles.profileAvatar}>AK</div>
              <div className={styles.profileInfo}>
                <div className={styles.profileName}>
                  Amara Kone{" "}
                  <span className={styles.verifyPill}>✓ Verified</span>
                </div>
                <div className={styles.profileRole}>
                  Senior Engineer · Lagos, Nigeria
                </div>
              </div>
            </div>

            {skills.map((s) => (
              <div key={s.label}>
                <div className={styles.skillRow}>
                  <span className={styles.skillLabel}>{s.label}</span>
                  <span className={styles.skillVal}>{s.val}%</span>
                </div>
                <div className={styles.skillBar}>
                  <div
                    className={styles.skillFill}
                    style={{ width: `${s.val}%` }}
                  />
                </div>
              </div>
            ))}

            <div className={styles.matchBanner}>
              <div className={styles.matchIcon}>⚡</div>
              <div className={styles.matchText}>
                <strong>96% match · Excellent fit</strong>
                <span>Aligned with your hiring rubric</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
